import { createStore } from "redux";
import { persistStore, persistReducer } from "redux-persist";
import reducer from "../redux/reducer";
import localStorage from "redux-persist/es/storage";

const PersistConfig = {
  key: "root",
  storage: localStorage,
};
const persistedReducer = persistReducer(PersistConfig, reducer);

export default () => {
  let store = createStore(persistedReducer);
  let persistor = persistStore(store);
  return { store, persistor };
};
